import styled from 'styled-components'
import JobTestBox from './JobTestBox'
import { useAppSelector } from '../../store'
import { useEffect, useState } from 'react'
import { TestUser } from '../../models/TestUser'
import { axiosPost } from './Axios'
import { Test } from '../../models/Test'
import { Link } from 'react-router-dom'
import { Result } from '../../models/Dto/Result'
import { ApiResult } from '../../models/Enums'

type Props = {
  setTestId?: (testId: number) => void
}

function TestList() {
  const me = useAppSelector((state) => state.user.me)
  const [testUsers, setTestUsers] = useState<TestUser[]>([])
  const [tests, setTests] = useState<Test[]>([])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-extra-semi
    ;(async () => {
      const payload = { id: me.id }
      try {
        const result = (await axiosPost(
          '/api/test/get_test_users',
          payload
        )) as Result

        if (result.apiResult !== ApiResult.SUCCESS) {
          console.log('get_test_users error', result.message)
          return
        }

        setTests(result.data['tests'])
        setTestUsers(result.data['testUsers'])
      } catch (error) {
        console.log('get_test_users error', error)
      }
    })()
  }, [me.id])

  return (
    <Container>
      {tests &&
        tests.length > 0 &&
        tests.map((test, index) => (
          <JobTestBox
            key={index}
            url={`/mentee/test/${test.id}`}
            name={test.name}
            button={
              testUsers.find((testUser) => testUser.testId === test.id)
                ? '결과확인하기'
                : '테스트하기'
            }
          />
        ))}
    </Container>
  )
}

const Container = styled.div`
  grid-area: leftside;

  @media (max-width: 768px) {
    display: none;
  }
`

export default TestList
